import React, { Component } from "react";
import { Link } from 'react-router-dom';
import Aspects from './Aspects';
import * as routes from '../Constants/routes';

class DeckGridRows extends Component {

  render() {

    var deckStyle = {
      background: "gold"
    }

    var textStyle = {
      fontWeight: 900,
      color: "black"
    }

  var dgrdecks = this.props.dgdecks;
    return (
      dgrdecks.map(function(dgrDeck, i){
        return (
          <tr>
            <td><Link to={routes.DECKVIEW + dgrDeck.id}>{dgrDeck.deckName}</Link></td>
            <td><Aspects deckAspects={dgrDeck.aspects} /></td>
            <td>{dgrDeck.author}</td>
            <td>{dgrDeck.cardCount}</td>
            <td>{dgrDeck.nanoCost}</td>
            <td>{dgrDeck.upVotes}</td>
            <td>{dgrDeck.Comments}</td>
            <td>{dgrDeck.addDate.toLocaleDateString()}</td>
            <td>

            {dgrDeck.Gold > 0 &&
              <span className="fa-layers fa-fw" >
                  <i color="gold" className="fas fa-trophy ml-1"></i>
                  <span className="fa-layers-text fa-inverse" data-fa-transform="shrink-8 up-3 right-3" style={textStyle}>{dgrDeck.Gold}</span>
              </span>
            }

            {dgrDeck.Silver > 0 &&
              <span className="fa-layers fa-fw" >
                  <i color="silver" className="fas fa-trophy ml-1"></i>
                  <span className="fa-layers-text fa-inverse" data-fa-transform="shrink-8 up-3 right-3" style={textStyle}>{dgrDeck.Silver}</span>
              </span>
            }

            {dgrDeck.Bronze > 0 &&
              <span className="fa-layers fa-fw" >
                  <i color="#8c7853" className="fas fa-trophy ml-1"></i>
                  <span className="fa-layers-text fa-inverse" data-fa-transform="shrink-8 up-3 right-3" style={textStyle}>{dgrDeck.Bronze}</span>
              </span>
            }

            </td>
          </tr>
        )
      })
    );
  }
}

export default DeckGridRows;



// WEBPACK FOOTER //
// ./src/DeckBuilderComponents/DeckGridRows.js